import { commonEnv } from "./environment.common";

const env: Partial<typeof commonEnv> = {
  BaseURL: 'https://api-dev.seuingressoaqui.com/v1'
};

export const environment = { ...commonEnv, ...env };
